import { useEffect, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

type Key = {
  transcriptId: number;
  tagId: number;
};
export const useTranscriptsSocket = (websocketKey?: Key): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Transcripts);

  useEffect(() => {
    if (websocketKey) {
      const newSocket = getSocket();
      setSocket(newSocket);

      newSocket.emit('subscribe', websocketKey.transcriptId);

      return () => {
        newSocket.emit('unsubscribe', websocketKey.transcriptId);
        newSocket.disconnect();
      };
    }
  }, [getSocket, websocketKey]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Transcripts);

  return socket;
};